export const calculateDepth = (hostWindow: Window, offset = 0): number => {
	let currentWindow = hostWindow;
	let hostFrameOffset = 0;

	while (currentWindow && currentWindow !== window.top) {
		hostFrameOffset += 1;
		currentWindow = currentWindow.parent;
	}

	return hostFrameOffset - offset;
};
